import { Link } from "react-router-dom";
import { products, type Product } from "../data/products";

type ProductCardProps = {
  productSpecific: Product;
};

export default function ProductCard({ productSpecific }: ProductCardProps) {
  const { slug, name, sku, images, short, discontinued, successorSlug } =
    productSpecific;
  const successor = successorSlug
    ? products.find((p) => p.slug === successorSlug)
    : undefined;
  return (
    <>
      <article className="card product-card">
        <Link to={`/produits/${slug}`}>
          <img
            loading="lazy"
            src={images[0]}
            alt={name}
            className="product-card-image"
            aria-label={name}
          />
        </Link>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginTop: 10,
          }}
        >
          <div>
            <div style={{ fontWeight: 700 }}>{name}</div>
            <div className="small">SKU: {sku}</div>
          </div>
        </div>
        {discontinued && (
          <span className="badge-discontinued">
            Modèle remplacé
            {successor
              ? ` par le ${
                  successor.sku.startsWith("Tresorsafe")
                    ? `TS${successor.sku.slice("Tresorsafe".length)}`
                    : successor.sku
                }`
              : ""}
          </span>
        )}
        <p className="small" style={{ marginTop: 8 }}>
          {short}
        </p>
        <div className="product-card-actions">
          <Link
            to={`/produits/${slug}`}
            className="btn"
            aria-label={`Voir ${name}`}
          >
            Voir le produit
          </Link>
        </div>
      </article>
    </>
  );
}
